import { AgentIcon } from '@/components/icons'
import capabilities from '@/lib/ondit/capabilities.json'
import { AgentBlock } from '@/blocks/blocks/agent'
import type { BlockConfig } from '@/blocks/types'

export const OnditBlock: BlockConfig = {
  type: 'ondit',
  name: 'Ondit',
  description: 'Run Ondit marketing operations with brand permissions and a shared credit budget',
  category: 'blocks',
  bgColor: AgentBlock.bgColor,
  icon: AgentIcon,
  subBlocks: [
    {
      id: 'capability',
      title: 'Marketing operation',
      preserveLabelCase: true,
      type: 'dropdown',
      required: true,
      options: capabilities.map((c) => ({
        id: c.id,
        label: c.label[0],
      })),
    },
    { id: 'inputs', title: '', type: 'operation-inputs', required: true, defaultValue: '{}' },
    {
      id: 'stallSeconds',
      title: 'No-progress timeout',
      type: 'short-input',
      placeholder: 'Seconds (60–21600)',
      description:
        'Leave empty to use the operation default. The timeout only applies while no progress is reported. Range: 60 seconds to 6 hours.',
    },
  ],
  tools: { access: [] },
  inputs: {
    capability: { type: 'string', description: 'Ondit capability ID' },
    inputs: { type: 'json', description: 'Capability inputs' },
    stallSeconds: {
      type: 'string',
      description: 'Seconds without progress before the run stops waiting',
    },
  },
  outputs: { result: { type: 'json', description: 'Completed Ondit operation result' } },
}
